import { handleApiCall } from "../HandleApi";
import config from "../../config.json"

export const _getRequestTokenResponse = (dataObj, customUrl) => {
  return handleApiCall({
    url: customUrl? customUrl : config.getJHHRequestTokenPath,
    method: "post",
    dataObj: dataObj,
    headers:{"Content-Type": "application/x-www-form-urlencoded"},
    requestBody: { type: Object, encryption: false,queryString:true },
  },
  );
};

export const _getRefreshTokenResponse = (dataObj) => {
  return handleApiCall(
    {
      url: config.getJHHRefreshTokenPath,
      method: "post",
      dataObj: dataObj,
      requestBody: { type: Object, encryption: true, queryString: true },
    },
    true,
    true,
    true
  );
};

export const _getRefreshTokenAckResponse = (dataObj) => {
  return handleApiCall(
    {
      url: config.getJHHRefreshTokenAckPath,
      method: "post",
      dataObj: dataObj,
      requestBody: { type: Object, encryption: true, queryString: true },
    },
    true,
    true,
    true
  );
};